import "react-toastify/dist/ReactToastify.min.css";
import BuyerSellerLayout from "../components/Layout";
import Breadcrumb from "../../SharedComponents/components/Breadcrumb/Breadcrumb";
import { useState } from "react";
import { OrderPartFormsEnum } from "../utils/enums/OrderPartFormsEnum";
import OrderPartForm from "../forms/OrderPartForm";
import AddUserCarForm from "../forms/AddUserCarForm";


const OrderPart = () => {

    const [selectedForm, setSelectedForm] = useState(OrderPartFormsEnum.ORDER_PART_FORM);

    const buyerBreadcrumbs = [
        { title: "Pocetak", href: "/home" },
        { title: "Naruci deo", href: "" },
    ];

    return (
        <BuyerSellerLayout>
            <Breadcrumb
                title={"Naruči deo"}
                breadcrumbs={buyerBreadcrumbs}
            />

            {(selectedForm === OrderPartFormsEnum.ORDER_PART_FORM) && (
                <OrderPartForm setSelectedForm={setSelectedForm} />
            )}

            {(selectedForm === OrderPartFormsEnum.ADD_CAR_FORM) && (
                <AddUserCarForm setSelectedForm={setSelectedForm} />
            )}


        </BuyerSellerLayout>
    );
};

export default OrderPart;
